import React from 'react';
import { trackCheckoutStart, trackEvent } from '../../Tracking/Matomo';
import Button from '../../form-elements/Button';
import { trackPinterestEvent } from '../../Tracking/Pinterest';

const InitiateCheckoutButton = function ({ legalType, cart, initiateCheckout }) {
    return (
        <Button
            fullWidth
            className="checkout_button next"
            onClick={async () => {
                trackCheckoutStart({
                    legalType,
                });
                trackEvent({
                    category: 'E-Commerce',
                    action: 'Klick-zur-Kasse',
                    label: `Zur Kasse - ${legalType}`,
                    value: (cart.stats.reservierung.grossProducts + cart.stats.onlineKauf.grossProducts) * 100,
                });
                trackPinterestEvent('checkout', {
                    value: (cart.stats.reservierung.grossProducts + cart.stats.onlineKauf.grossProducts) * 100,
                    currency: 'EUR',
                });
                await initiateCheckout(legalType);
            }}
        >
            {legalType === 'online-kauf' ? 'ZUR KASSE' : 'Zur Reservierung'}
        </Button>
    );
};

export default InitiateCheckoutButton;
